import React, { useState } from 'react';
import PropTypes from 'prop-types';
import bundledLogo from 'assets/img/pebsteel.png';
import { PUBLIC_LOGO_URL } from 'helpers/useAppSetting';

// The APP_LOGO AppSetting, served without sign-in by GET /api/v1/app_settings/logo
// (redirects to the uploaded image, 404 when none). The login page runs before the
// app settings are loaded into redux, so it reads the image straight from there and
// falls back to the bundled logo when nothing is uploaded or the API is unreachable.

const BrandLogo = ({ className, alt = 'Company logo' }) => {
  const [failed, setFailed] = useState(false);
  return (
    <img
      src={failed ? bundledLogo : PUBLIC_LOGO_URL}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

BrandLogo.propTypes = { className: PropTypes.string, alt: PropTypes.string };

export default BrandLogo;
